// extracted by mini-css-extract-plugin
export default {"headerLink":"enrichments_headerLink__nLDAs","link":"enrichments_link__GbVqw"};